import { TransactionStatus } from '../gateways/types';
import { getPspDisplayName, getPspLabel, pspLabel } from 'utils/psp';
const TransationStatus: Record<TransactionStatus, string> = {
    created: 'ایجاد شده',
    callback_success: 'پرداخت موفق-بانک',
    callback_unsuccess: 'پرداخت ناموفق-بانک',
    interface: 'پرداخت غیرمستقیم',
    bank: 'ورود به بانک',
    verify_success: 'وریفای شده موفق',
    verify_unsuccess: 'وریفای شده ناموفق',
    sandbox: 'سندباکس',
    revers: 'عودت وجه-بانک',
    cancel: 'انصراف از پرداخت',
    withdraw_pending: 'در انتظار تسویه',
    withdraw_success: 'تسویه شده',
    expire: 'منقضی شده',
};

const TransationType: Record<string, string> = {
    api: 'وبسرویس',
    charge: 'شارژ',
    service: 'سرویس',
};


const getTransactionStatusLabel = (
    status: TransactionStatus | undefined,
): string => {
    return status ? (TransationStatus[status] ?? '-') : '-';
};

const getTransactionTypeLabel = (type: string | undefined): string => {
    return type ? TransationType[type] : '-';
};

export {
    TransationStatus,
    getPspLabel,
    getPspDisplayName,
    TransationType,
    pspLabel,
    getTransactionStatusLabel,
    getTransactionTypeLabel,
};
